import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import { DocumentAddItemsType } from '@/api/product/model/documentAddModel'

const actions: { [actionTypes: string]: Action<State, any> } = {
    //ドキュメント新規登録 Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_ACTIVE_STATUS]: (
        { commit },
        status: boolean
    ): void => commit(actionTypes.SET_MODAL_DOCUMENT_ADD_ACTIVE_STATUS, status),

    //キャンセル Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_CANCEL_ACTIVE_STATUS]: (
        { commit },
        status: boolean
    ): void => commit(actionTypes.SET_MODAL_DOCUMENT_ADD_CANCEL_ACTIVE_STATUS, status),

    //登録 Modal status
    [actionTypes.SET_MODAL_DOCUMENT_ADD_SUBMIT_ACTIVE_STATUS]: (
        { commit },
        status: boolean
    ): void => commit(actionTypes.SET_MODAL_DOCUMENT_ADD_SUBMIT_ACTIVE_STATUS, status),

    //ドキュメント新規登録 画面データ
    [actionTypes.SET_DOCUMENT_ADD_ITEMS]: (
        { commit },
        payload: DocumentAddItemsType
    ): void => commit(actionTypes.SET_DOCUMENT_ADD_ITEMS, payload),

    //ドキュメント新規登録 備考チェック
    [actionTypes.SET_REMARK_CHECK_ERROR]: (
        { commit },
        errorMessage: string
    ): void => commit(actionTypes.SET_REMARK_CHECK_ERROR, errorMessage),

    //ドキュメント新規登録　チェックエラー
    [actionTypes.SET_HAS_ERR]: (
        { commit },
        status: boolean
    ): void => commit(actionTypes.SET_HAS_ERR, status),

    //ドキュメント新規登録　チェックエラー
    [actionTypes.SET_ADD_OK]: (
        { commit },
        status: boolean
    ): void => commit(actionTypes.SET_ADD_OK, status),

    //ドキュメントデータ
    [actionTypes.SET_DOCUMENT_DATAS]: (
        { commit },
        payload: Array<any>
    ): void => commit(actionTypes.SET_DOCUMENT_DATAS, payload),

}

export default actions
